module.exports = __webpack_public_path__ + "img/Septris-sprite-doors-open.1ffd2528.png";